export enum PrinterType {
  Epson = 0,
  Star = 1,
  MyPos = 4,
  MyPosMini = 5,
  Sunmi = 6,
  Adyen = 7,
}
